import { type ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';
import { type IAsyncSelectWidget } from '../../IAsyncSelectWidget.ts';

function getColumns(widget: IAsyncSelectWidget): ColumnsType<any> {
  return (
    widget.table?.columns.map(col => ({
      title: col.label,
      dataIndex: col.value,
      key: col.value,
    })) ?? []
  );
}

export function useAsyncServiceTableColumns(widget: IAsyncSelectWidget) {
  const columns = useMemo(() => getColumns(widget), [widget]);
  return columns;
}
